import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { AppContextService } from '@core/services/app-context.service';

import { PendingIssueItemComponent } from './pending-issue-item/pending-issue-item.component';

@Component({
  standalone: true,
  selector: 'mw-pending-issues-notification',
  imports: [PendingIssueItemComponent],
  templateUrl: './pending-issues-notification.component.html',
  styleUrl: './pending-issues-notification.component.scss'
})
export class PendingIssuesNotificationComponent {
  private readonly appCtx = inject(AppContextService);

  readonly pendingIssues = toSignal(this.appCtx.pendingIssues$);

  readonly organizedPendingIssues = computed(() => {
    return this.pendingIssues()?.result.sort(
      (a, b) => b.issues.length - a.issues.length
    );
  });

  readonly isEveryBookSent = computed(() => {
    return this.pendingIssues().result.every((item) => !!item.isFinished);
  });
}
